export const getCacheBusterKey = (suffix: string) => `CACHE_BUSTER_${suffix}`;

export const getCacheBuster = (suffix: string): string | null => {
    return localStorage.getItem(getCacheBusterKey(suffix));
};

export const refreshCacheBuster = (suffix: string): string => {
    const newValue = Date.now().toString();
    localStorage.setItem(getCacheBusterKey(suffix), newValue);
    return newValue;
};

export const clearCacheBuster = (suffix: string) => {
    localStorage.removeItem(getCacheBusterKey(suffix));
};
